import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const ChatBot = () => {
  return (
    <a
      href="https://wa.me/447440373308?text=Hello!%20I'm%20interested%20in%20your%20tutoring%20services.%20Can%20you%20help%20me%20with%20academic%20support?"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 hover:scale-110 transition-all duration-300 flex items-center justify-center animate-bounce"
      title="Instant WhatsApp"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="w-8 h-8" />
    </a>
  );
};

export default ChatBot;
